import { Container } from "@/shared/components/layout/Container";
import { Section } from "@/shared/components/layout/Section";
import { Reveal } from "@/shared/components/motion/Reveal";
import { MarketingCtas } from "../MarketingCtas";

/**
 * Closing call to action. A prominent `glass-surface-strong` panel (the §8 role
 * for hero CTAs) with the marketing CTA display headline, revealed as a single
 * block on scroll.
 */
export function FinalCtaSection() {
  return (
    <Section spacing="marketing">
      <Container size="5xl">
        <Reveal>
          <div className="flex flex-col items-center gap-6 rounded-2xl glass-surface-strong px-8 py-16 text-center md:py-20">
            <h2 className="type-display-cta max-w-3xl text-text">
              Everyone you're hosting, gathered in one place.
            </h2>
            <p className="type-body-lg max-w-2xl text-text-muted">
              Begin collecting, organizing, and sharing your guest list today —
              calmly, and beautifully.
            </p>
            <MarketingCtas primaryLabel="Get Started Free" className="justify-center" />
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
